import {Brand} from '@vio/core/src/brand/types'

// Referral program is disabled - see SC-175262
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useIsReferralProgramEnabled = (_brand?: Brand) => {
  return false
}
